/* eslint-disable camelcase */
import React, { useState } from 'react'
import './style.scss'
import { ticketService } from '../../services/ticket.service'
import { useAuth } from '../../hooks/useAuth'
// import { useSpring, animated } from 'react-spring'

export const UpcomingTicketCard = (props) => {
  const [isLoading, setIsLoading] = useState()
  const [showTransferButton, setShowTransferButton] = useState(false)
  const {
    activo,
    aprobado,
    ciudad,
    descripcion,
    direccion,
    divisa,
    estado,
    fecha_creado,
    fecha_modificado,
    foto_portada,
    funcion,
    id_categoria_fk,
    id_tipo_boleto_fk,
    latitud,
    longitud,
    nombre,
    nombre_artista,
    ubicacion,
    video,
    fecha_funcion,
    hora_fin,
    codigo_qr,
    fecha_asistencia,
    hora_inicio,
    bid
  } = props

  const dia = Number(fecha_asistencia.substring(0, 2))
  const mes = Number(fecha_asistencia.substring(3, 5))
  const año = Number(fecha_asistencia.substring(6, 10))
  const hora = Number(hora_inicio.substring(0, 2))

  const [compadre, setCompadre] = useState('')
  const { user } = useAuth()

  const handleChange = (event) => {
    setCompadre(event.target.value)
    const phoneNumber = event.target.value
    // check if phone number is in the format +52 4428623044
    const isValid = /^\d{10}$/.test(phoneNumber)
    setShowTransferButton(isValid)
  }
  const id_boleto = bid

  const transferTicket = async () => {
    try {
      const transfer = await ticketService.tT((id_boleto), {
        usuario_anterior: user.uid,
        compadrecel: compadre
      })
    } catch (error) {
      console.log(error)
    }
  }

  const today = new Date()
  const inputDate = new Date(año, mes - 1, dia, hora)

  // Add this code
  // const buttonSpring = useSpring({
  //   opacity: showTransferButton ? 1 : 0,
  //   transform: showTransferButton ? 'translateY(0)' : 'translateY(-10px)'
  // })

  if (inputDate > today && inputDate - today <= 2 * 60 * 60 * 1000) {
    return (
    // code for the first condition
    <div className="cardTicket">
  <div className='row'>
    <div className="col-md-4 mb-4 mt-4">
      <div className="flip-card mb-4">
        <div className = "flip-card-inner">
          <div className="flip-card-front">
            <div className="img-wrapper3">
              <img src={codigo_qr} className="card img-top img-fluid" />
            </div>
          </div>
          <div className="flip-card-back">
            <div className="img-wrapper3">
              <img src={codigo_qr} className="card img-top img-fluid" />
            </div>
          </div>
        </div>
        <div className='flip-card-buton'>
          <button type="button" className="btn btn-primary">
            Código QR
          </button>
        </div>
      </div>
    </div>
    <div className="col-md-6 mt-4">
      <h4>Nombre</h4>
      <ul className="list-unstyled mb-5">
        <li className="d-flex align-items-center mb-2">
          <b>Fecha: {fecha_asistencia}</b>
        </li>
        <li className="d-flex align-items-center mb-2 flex-wrap">
          <b></b>
        </li>
        <li className="d-flex align-items-center mb-2">
          <b>Ciudad: Ciudad</b>
        </li>
        <li className="d-flex align-items-center mb-2">
          <b>Direccion: Dirección</b>
        </li>
      </ul>
      <input className="form-control" type="text" placeholder="Enter phone number" onChange={handleChange} />
  { showTransferButton && (
    <button className={`btn btn-primary ${isLoading ? 'disabled' : ''}`} onClick={transferTicket}>
      {isLoading ? (<> <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span className="sr-only">Loading...</span></>) : ('Transfer to your compadre')}
    </button>
  )}
    </div>
  </div>
</div>
    )
  } else if (inputDate > today) {
    return (
      <div className="cardTicket">
  <div className='row'>
    <div className="col-md-4 mb-4 mt-4">
      <div className="flip-card mb-4">
        <div className = "flip-card-inner">
          <div className="flip-card-front">
            <div className="img-wrapper3">
              <img src={codigo_qr} className="card img-top img-fluid" />
            </div>
          </div>
          <div className="flip-card-back">
            <div className="img-wrapper3">
              <img src={codigo_qr} className="card img-top img-fluid" />
            </div>
          </div>
        </div>
        <div className='flip-card-buton'>
          <button type="button" className="btn btn-primary">
            Código QR
          </button>
        </div>
      </div>
    </div>
    <div className="col-md-6 mt-4">
      <h4>Nombre</h4>
      <ul className="list-unstyled mb-5">
        <li className="d-flex align-items-center mb-2">
          <b>Fecha: {fecha_asistencia}</b>
        </li>
        <li className="d-flex align-items-center mb-2 flex-wrap">
          <b></b>
        </li>
        <li className="d-flex align-items-center mb-2">
          <b>Ciudad: Ciudad</b>
        </li>
        <li className="d-flex align-items-center mb-2">
          <b>Direccion: Dirección</b>
        </li>
      </ul>
      <input className="form-control" type="text" placeholder="Enter phone number" onChange={handleChange} />
  { showTransferButton && (
    <button className={`btn btn-primary ${isLoading ? 'disabled' : ''}`} onClick={transferTicket}>
      {isLoading ? (<> <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span className="sr-only">Loading...</span></>) : ('Transfer to your compadre')}
    </button>
  )}
    </div>
  </div>
</div>

    )
  }
}
